export const CART_NOTE_UPDATE = `
  mutation cartNoteUpdate($cartId: ID!, $note: String!) {
  cartNoteUpdate(cartId: $cartId, note: $note) {
    cart {
      note
    }
    userErrors {
      field
      message
    }
  }
}
`
